import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Icon } from "@/components/Atoms/Icon"
import { useNavigate } from "react-router-dom"

interface FaceCaptureModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export function FaceCaptureModal({ isOpen, onOpenChange }: FaceCaptureModalProps) {
  const navigate = useNavigate()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            <div className="flex gap-3 pb-3">
              <Icon
                name="face-viewfinder"
                state="elegant"
              />
              Reconhecimento Facial
            </div>
          </DialogTitle>
          <DialogDescription>
            Membro Giants, cadastre sua biometria facial para facilitar e agilizar o seu acesso a
            casa dos empresários.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex flex-1 flex-col gap-2">
            <Button
              className="bg-orange-500/90 text-black hover:bg-orange-500"
              onClick={() => {
                navigate("/face-capture")
                onOpenChange(false)
              }}
            >
              Vamos lá!
            </Button>
            <Button
              className="text-red-500 hover:bg-red-500/10 hover:text-red-500"
              variant="ghost"
              onClick={() => onOpenChange(false)}
            >
              Não quero facilitar meu acesso
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
